<template>
    <div>
        <treeselect
                valueFormat="object"
                v-model="currentSelected"
                :multiple="false"
                :async="true"
                :load-options="loadOptions"
                :clear-on-select="true"
                ref="select"

                :placeholder="currentLang.placeholder"
                :retryTitle="currentLang.retryTitle"
                :retryText="currentLang.retryText"
                :noOptionsText="currentLang.noOptionsText"
                :noResultsText="currentLang.noResultsText"
                :noChildrenText="currentLang.noChildrenText"
                :searchPromptText="currentLang.searchPromptText"
                :clearValueText="currentLang.clearValueText"
                :clearAllText="currentLang.clearAllText"
        ></treeselect>

        <div class="form-group mt10" v-if="currentSelected">
            <label v-text="product.code + ' - ' + product.title + ' combiprijs'"></label>
            <input type="number" step="0.01" :name="'combideal[' + currentSelected.id + '][price_1]'" :value="formatPrice(currentSelected.price_1)" class="form-control col-2 mb5" />

            <label v-text="currentSelected.label + ' combiprijs'"></label>
            <input type="number" step="0.01" :name="'combideal[' + currentSelected.id + '][price_2]'" :value="formatPrice(currentSelected.price_2)" class="form-control col-2" />
        </div>

        <input type="hidden" :name="name" v-model="encodedData" />
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        components: {
            Treeselect
        },
        props: {
            lang: {
                required: false,
                type: Object,
            },
            selected: {
                required: false,
                type: Object|Array
            },
            options: {
                required: false,
                type: Array
            },
            name: {
                required: true,
                type: String
            },
            product: {
                required: true,
                type: Object,
            }
        },
        data: function () {
            return {
                currentLang: {
                    'placeholder': 'Select...',
                    'retryTitle': 'Click to retry',
                    'retryText': 'Retry?',
                    'noOptionsText': 'No options available.',
                    'noResultsText': 'No results found...',
                    'noChildrenText': 'No sub-options.',
                    'searchPromptText': 'Type to search...',
                    'clearValueText': 'Clear value',
                    'clearAllText': 'Clear all'
                },
                currentSelected: null,
                currentOptions: []
            }
        },
        methods: {
            loadOptions: _.debounce(({action, searchQuery, callback}) => {
                axios.get(`/api/backend/products?search=${searchQuery}`)
                    .then(response => {
                        let options = [];
                        if (response.data.hasOwnProperty('data')) {
                            options = response.data.data.map(i => ({
                                id: `${i.id}`,
                                label: `${i.label}`,
                                price_1: null,
                                price_2: null
                            }));
                        }
                        callback(null, options)
                    });
            }, 500),
            changeLang() {
                _.forEach(this.lang, (value, key) => {
                    this.currentLang[key] = value;
                });
            },
            formatPrice(price){
                return (parseFloat(price) / 100).toLocaleString(
                    undefined, // leave undefined to use the browser's locale,
                    // or use a string like 'en-US' to override it.
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                ).replace(",", ".");
            },
        },
        computed: {
            encodedData() {
                if(this.currentSelected !== null) {
                    return JSON.stringify(this.currentSelected);
                }
                else {
                    return "";
                }
            }
        },
        mounted() {

            if(this.selected && this.selected.pivot != undefined) {
                this.currentSelected = {
                    id: `${this.selected.id}`,
                    label: `${this.selected.code} - ${this.selected.title}`,
                    price_1: this.selected.pivot.price_1,
                    price_2: this.selected.pivot.price_2,
                };
            }


            this.changeLang();
        },
        created() {
        }

    }
</script>
